import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { SaveDeferredCompensationDTO } from '../forms/DeferredCompensation/DeferredCompensationForm.meta';
import { UPSERT_ASSET_MK } from '../components/UpsertAssetModal/UpsertAssetModal.meta';
import { queryKeys } from './queryKeys';

export const SAVE_DEFERRED_COMPENSATION_ENDPOINT =
  '/Consumer/OtherAssetsUpdate/SaveDeferredCompensation';

const saveDeferredCompensation = (body: SaveDeferredCompensationDTO): Promise<null> => {
  return authFetch(SAVE_DEFERRED_COMPENSATION_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

interface Params {
  clientId: string;
}

export const useSaveDeferredCompensationMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(saveDeferredCompensation, {
    mutationKey: [UPSERT_ASSET_MK, 'deferredCompensation'],

    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.otherAssets(clientId));
    },
  });
};
